import type { CombinedError } from "urql"
import { useQuery } from "urql"
import { graphql } from "@/graphql"
import { useCurrentUser } from "./useCurrentUser"

const TenantOnboardingStatusQuery = graphql(`
  query TenantOnboardingStatus {
    tenant {
      restaurant {
        id
      }
    }
  }
`)

const hasNotFoundError = (error?: CombinedError) =>
  error?.graphQLErrors.some((graphQLError) => graphQLError.extensions?.code === "NOT_FOUND") ??
  false

export const useTenantOnboardingStatus = () => {
  const currentUser = useCurrentUser()
  const shouldCheckProfile = Boolean(currentUser?.emailVerified)

  const [{ data, fetching, error }] = useQuery({
    query: TenantOnboardingStatusQuery,
    pause: !shouldCheckProfile,
  })

  const hasTenantProfile = Boolean(data?.tenant?.restaurant?.id)
  const needsOnboarding = shouldCheckProfile && hasNotFoundError(error)
  const isResolving = shouldCheckProfile && fetching && !data && !error

  return {
    hasTenantProfile,
    isResolving,
    needsOnboarding,
  }
}
